import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { StatsGrid, StatsCard } from './style';

import ActiveShiftsIcon from '../../../../assets/FacilityDashboard/active-shifts.svg'
import UpcomingShiftsIcon from '../../../../assets/FacilityDashboard/upcoming-shifts.svg'
import AssignedWorkersIcon from '../../../../assets/FacilityDashboard/assigned-workers.svg'
import TotalShiftsIcon from '../../../../assets/FacilityDashboard/total-shifts.svg'

import { AppDispatch } from '../../../../store';
import { fetchFacilityDashboardStatistics, selectFacilityDashboardStatistics } from '../../../../modules/facility';

const ShiftOverview: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const statistics = useSelector(selectFacilityDashboardStatistics);

  useEffect(() => {
    dispatch(fetchFacilityDashboardStatistics());
  }, [dispatch]);

  const stats = [
    {
      title: 'Active Shifts (Today)',
      value: statistics?.active_shifts_today_count ?? 0,
      subtext: statistics?.last_clock_in ? `Last clock-in: ${dayjs(statistics.last_clock_in).format('h:mm A')}` : 'No recent clock-in',
      icon: <img src={ActiveShiftsIcon} alt="active-shifts-icon" />,
      bg: '#fff3e0',
    },
    {
      title: 'Upcoming Shifts',
      value: statistics?.upcoming_shifts_count ?? 0,
      subtext: 'All created',
      icon: <img src={UpcomingShiftsIcon} alt="upcoming-shifts-icon" />,
      bg: '#e3f2fd',
    },
    {
      title: 'Assigned Workers',
      value: statistics?.assigned_workers_count ?? 0,
      subtext: `Unassigned: ${statistics?.unassigned_open_shifts_count ?? 0} open shifts`,
      icon: <img src={AssignedWorkersIcon} alt="assigned-workers-icon" />,
      bg: '#fbe9e7',
    },
    {
      title: 'Total Number of Shifts',
      value: statistics?.total_shifts_count ?? 0,
      subtext: 'Upcoming and Completed',
      icon: <img src={TotalShiftsIcon} alt="total-shifts-icon" />,
      bg: '#e8f5e9',
    },
  ];

  return (
    <StatsGrid>
      {stats.map((stat, index) => (
        <StatsCard key={index}>
          <Box sx={{
            width: 56,
            height: 56,
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: stat.bg, // Applied background color
            flexShrink: 0
          }}>
            {stat.icon}
          </Box>
          <Box>
            <Typography variant="body2" sx={{ fontSize: '0.95rem', color: '#333333', fontWeight: 500, lineHeight: 1.4 }}>{stat.title}</Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '1.75rem', lineHeight: 1.1, my: 1 }}>{stat.value}</Typography>
            <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#777777', mt: 1, display: 'block' }}>{stat.subtext}</Typography>
          </Box>
        </StatsCard>
      ))}
    </StatsGrid>
  );
};

export default ShiftOverview;
